export interface ConfirmAddress {
    address: string;
}
